# Using this in the chart builder
window.reloadDCID = (dcid, chartId, chsid) ->
	Charts = angular.element('#dashView').injector().get("Charts")
	Charts.chartSaved(dcid)
	return

# most of the parameters are here for legacy dashboard support
# Using this in the chart builder
window.createAChartBox = (dcid, columnIndex, chsid, readonly, minutesBeforeReload, addToTop, chid) ->
	Charts = angular.element('#dashView').injector().get("Charts")
	Charts.chartAdded(dcid)

# Using this in the chart builder
window.closeChartBuilder = () ->
  dashService = angular.element('#dashView').injector().get("dashboardService")
  dashService.closeChartBuilder()
  return

# Using this in the chart builder
window.isSharedDashboard = () ->
  dashService = angular.element('#dashView').injector().get("dashboardService")
  return dashService.isSharedDashboard()

# Using this in the chart builder
window.getCurrentUserId = () ->
  appService = angular.element('#dashView').injector().get("app")
  return appService.getUserId()
